import { wrapperBuilder } from './build';

const functionsRegister = wrapperBuilder.getFunctionsRegisterInstance();

functionsRegister.addFunction('setValue', wrapperEnvironment => val => {
  wrapperEnvironment.variablesHandler.variablesSetter('value')(val);
});
